import { Modal } from "@mixitone/components";
import { omit } from "@mixitone/util";
import { ApplicationView } from "@mixitone/mvc";
import RouteController from "controllers/RouteController";
import { TelemetryErrorBoundary as ErrorBoundary } from "@mixitone/telemetry";

type Props = Omit<React.ComponentProps<typeof Modal>, "onClose">;

const ErrorState = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <p className="mb-4 text-lg font-medium">Something went wrong</p>
        <p className="text-sm text-gray-600">Please try again later</p>
      </div>
    </div>
  );
};

const AppModal: React.FC<Props> = (props) => {
  const controller = RouteController.use();

  return (
    <Modal
      {...omit(props, ["children"])}
      onClose={() => {
        controller.actionCloseModal();
      }}
    >
      <ErrorBoundary fallback={<ErrorState />}>{props.children}</ErrorBoundary>
    </Modal>
  );
};

export default ApplicationView(AppModal);
